import React from 'react';
import { Header } from 'components/Header';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { ThemedProvider } from 'themed-components';
import { QueryClientProvider } from 'react-query';
import { CreateRoute } from './components/CreateRoute';

import { MailReviewView } from './pages/MailReview';
import { MailroomView } from './pages/MailRoom';
import { Wrapper } from 'ui-library';
import { SnackbarHandlerProvider } from 'context/SnackbarContext';
import { Provider as ReduxProvider } from 'react-redux';
import { User } from 'oidc-client';
import { OidcProvider } from 'redux-oidc';
import userManager from 'lib/auth/UserManager';
import store from 'store/Store';
import UserProfileLoader from 'context/UserProfileLoader';
import { queryClient } from 'lib/queryClient';
import { SnackbarContainer } from 'components/SnabarContainer';

const views = [
	CreateRoute({ path: '/mail', params: { exact: true }, component: <MailReviewView /> }),
	CreateRoute({ path: '/mail/:id', params: { exact: true }, component: <MailReviewView /> }),
	CreateRoute({ path: '/', params: { exact: true }, component: <MailroomView /> })
];

const Views = () => (
	<Wrapper>
		<Switch>{views}</Switch>
	</Wrapper>
);

interface AppProps {
	authenticatedUser: User;
}

export const App = ({ authenticatedUser }: AppProps) => {
	return (
		<ThemedProvider>
			<ReduxProvider store={store}>
				<OidcProvider store={store} userManager={userManager}>
					<QueryClientProvider client={queryClient}>
						<UserProfileLoader authenticatedUser={authenticatedUser}>
							<SnackbarHandlerProvider>
								<Router>
									<Header />
									<Views />
								</Router>
								<SnackbarContainer />
							</SnackbarHandlerProvider>
						</UserProfileLoader>
					</QueryClientProvider>
				</OidcProvider>
			</ReduxProvider>
		</ThemedProvider>
	);
};
